module.exports = __webpack_public_path__ + "img/img1.f4df047b.png";